import { render, staticRenderFns } from "./TransferUserStaff.vue?vue&type=template&id=b26656c4&"
import script from "./TransferUserStaff.vue?vue&type=script&lang=js&"
export * from "./TransferUserStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports